// extracted by mini-css-extract-plugin
module.exports = {"hide":"styles_hide__39Zud","text":"styles_text__2tRlP"};